import { Link } from 'react-router-dom';
import styled from 'styled-components';
import tw from 'twin.macro';
import { Alert, LoadingBlock, Stack } from '../../components/ui';
import { problemAction, type WizardStepId } from './workerForm';

const ProblemButton = styled.button`
  ${tw`p-0 text-sm font-medium underline cursor-pointer`}
  border: none;
  background: none;
  color: inherit;
`;

/** The publish checklist with a way to fix each problem, plus the D26 warnings. */
export function PublishChecklist({
  problems,
  warnings,
  onGoTo,
}: {
  problems: { code: string; message: string }[] | null;
  warnings: string[];
  onGoTo?: (step: WizardStepId) => void;
}) {
  return (
    <Stack $gap={4}>
      {problems === null ? (
        <LoadingBlock label="Checking your worker" />
      ) : problems.length === 0 ? (
        <Alert tone="success" title="Ready to publish">
          Customers can find and book this worker as soon as you publish.
        </Alert>
      ) : (
        <Alert tone="warning" title="Before you publish">
          <Stack $gap={4} data-testid="worker-publish-problems">
            {problems.map(problem => {
              const action = problemAction(problem.code);
              return (
                <div key={problem.code}>
                  {problem.message}{' '}
                  {action.kind === 'step' && onGoTo && (
                    <ProblemButton type="button" onClick={() => onGoTo(action.step)}>
                      Fix
                    </ProblemButton>
                  )}
                  {action.kind === 'link' && <Link to={action.to}>{action.label}</Link>}
                </div>
              );
            })}
          </Stack>
        </Alert>
      )}
      {warnings.length > 0 && (
        <Alert tone="info" title="Low prices">
          <Stack $gap={4} data-testid="worker-price-warnings">
            <div>These prices work out below the local minimum wage. You can still publish.</div>
            {warnings.map(text => (
              <div key={text}>{text}</div>
            ))}
          </Stack>
        </Alert>
      )}
    </Stack>
  );
}
